import styled from 'styled-components'
import { mediaURL } from 'src/consumer/services'
import { Link } from 'react-router-dom'

const bgImg = 'MEDIA-f843372afcef4a9bac3a654b9ef8443f'

export const GiftCardOptionsWrapper = styled.div`
  background-color: black;
  padding: 0 20px;
`

export const GiftCardOptionsHeader = styled.div`
  font-weight: 600;
  letter-spacing: -0.5px;
  color: #ffffff;
  text-align: center;
  font-size: 40px;
  line-height: 49px;
  padding-top: 88px;
  padding-bottom: 75px;
  font-size: 30px;
  line-height: 40px;
  padding-top: 48px;
  padding-bottom: 35px;
  @media (min-width: 768px) {
    font-size: 40px;
    line-height: 49px;
    padding-top: 88px;
    padding-bottom: 75px;
  }
`

export const GiftCardHomepageWrapper = styled.div`
  background-color: black;
  width: 100%;
  font-family: Outfit;
  height: calc(100vh - 64px);
  background-image: url(${mediaURL}${bgImg});
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
`

export const GiftCardHomepageHeader = styled.div`
  font-weight: 700;
  letter-spacing: -0.5px;
  color: #ffffff;
  line-height: 40px;
  font-size: 30px;
  padding-bottom: 15px;
  @media (min-width: 768px) {
    line-height: 73px;
    font-size: 60px;
    padding-bottom: 30px;
  }
`

export const GiftCardHomepageContent = styled.div`
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.5px;
  color: #ffffff;
  font-size: 16px;
  line-height: 24px;
  @media (min-width: 768px) {
    font-size: 25px;
    line-height: 30px;
  }
`

export const GiftCardHomepageButtons = styled.div`
  padding-top: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  @media (min-width: 768px) {
    padding-top: 120px;
    flex-direction: row;
  }
`

export const GiftCardOptionsButton = styled.button`
  background: #ed0381;
  box-shadow: 10px 12px 13px rgba(0, 0, 0, 0.38);
  border-radius: 19px;
  width: 250px;
  height: 50px;
`

export const GiftCardRedeemLink = styled(Link)`
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: #ffffff;
  :hover {
    color: #ffffff;
  }
`

export const GiftCardOptionsLink = styled.div`
  text-decoration: none;
  font-style: normal;
  font-weight: 600;
  font-size: 21px;
  line-height: 26px;
  letter-spacing: -0.5px;
  color: #ffffff;
  :hover {
    color: #ffffff;
  }
`
